import { CONSTANTS } from '@bootstrap/helper';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appConfigs: any = {};

export class AppConfig {
  public async loader(): Promise<void> {
    try {
      const result = await fetch(CONSTANTS.CONFIG_PATH);
      const configs = await result.json();

      for (const prop in appConfigs) {
        delete appConfigs[prop];
      }

      for (const prop in configs) {
        appConfigs[prop] = configs[prop];
      }
    } catch ({ message }) {
      throw new Error(message + '');
    }
  }
}
